import { Button, Link } from '@lounge-fe/ui-kit'
import { SignupFormLayout } from '../SignupFormLayout'
import { IntroductionFrictionStepProps } from './types'
import { twMerge } from 'tailwind-merge'

export const IntroductionFriction = ({
  className,
  html,
  title,
  subtitle,
  buttonText,
  onNext,
  isDarkMode = false,
  ...props
}: IntroductionFrictionStepProps) => (
  <SignupFormLayout.FormContainer
    className={twMerge('h-full', className)}
    {...props}
  >
    {html && <div dangerouslySetInnerHTML={{ __html: html }} />}
    {title && <SignupFormLayout.Title>{title}</SignupFormLayout.Title>}
    {subtitle && (
      <SignupFormLayout.Subtitle>{subtitle}</SignupFormLayout.Subtitle>
    )}
    <Link
      className="link link--size-lg"
      onClick={onNext}
      color={isDarkMode ? 'secondary' : 'primary'}
    >
      {buttonText}
    </Link>
  </SignupFormLayout.FormContainer>
)
